import { select, put, all } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import selectors from "rdx/selectors";
import actions from "rdx/actions";
import messages from "../messages";

function* deleteDashboardPromotion(action) {
  const { id } = action.payload;
  const { success, data, error } = yield* makeRequest.delete(`/dashboard_promotions/${id}`, {});

  if (success && data) {
    const list = yield select(selectors.selectDashboardPromotions);
    const out = list.promotions.filter((item) => {
      return item.id !== id;
    });

    yield all([
      put(actions.setDashboardPromotions({ ...list, promotions: out })),
      put(
        actions.newSuccessEvent({
          message: messages.DELETE_DASHBOARD_PROMOTION_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.GET_EVENTS_AND_PROMOS_ERROR,
    });
  }
  return null;
}

export default deleteDashboardPromotion;
